<template>
<div :class="{loading: loading}" >
  <v-toolbar
    v-if='client && client.id' dense flat  >
    <slot name="toolbar-icon" >
      <v-toolbar-side-icon v-if='withPrevNext' >
        <v-btn icon small @click='$emit("prev")' >
          <v-icon>arrow_left</v-icon>
        </v-btn>
      </v-toolbar-side-icon>
    </slot>
    <v-toolbar-title >
      <slot name="header" >
        <v-menu v-if='withClientPreview && relationshipId'
          v-model="clientPreviewMenu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x >
          <v-btn slot="activator" icon >
            <v-icon v-if='clientPreviewMenu' class='mr-2' >visibility_off</v-icon>
            <v-icon v-else class='mr-2' >visibility</v-icon>
          </v-btn>

          <v-card :min-width='280'>
            <client-card :relationship-id='relationshipId' >
            </client-card>
          </v-card>
        </v-menu>
        {{normalizedClient.first_name}} {{normalizedClient.last_name}}.
      </slot>
      <slot name="subheader" >
      </slot>
    </v-toolbar-title>
    <v-spacer>
    </v-spacer>
    <slot name="toolbar-buttons" ></slot>
    <filters
      v-if='withFilters'
      :statement='statement'
      :with-actions='true'
      :filter-from-date='filterFromDate'
      :filter-to-date='filterToDate'
      :filter-status-ids='filterStatusIds'
      :touch-show='filterTouch'
      v-model='filters'
      @filters:string='setFilterString'
      @filters:params='setFilters' >
      </filters>

    <v-btn
      v-if='withReload'
      :loading='loading'
      icon small
      @click='$emit("reload", this.filters)' >
      <v-icon>replay</v-icon>
    </v-btn>
    <v-btn
      v-if='withPrevNext'
      icon small @click='$emit("next")' >
      <v-icon>arrow_right</v-icon>
    </v-btn>

    <span v-if='withFilters' class='py-0 my-0' slot="extension" >
      <span v-if='filterString' >{{filterString}}</span>
      <span v-if='!filterString && initialFilterText' >{{initialFilterText}}</span>
      <v-btn class='hidden-xs-only' @click='filterTouch++' flat small>Edit</v-btn>
      <v-btn class='hidden-xs-only' @click='clearFilters' flat small>Clear</v-btn>
    </span>
  </v-toolbar>

  <!-- <h3 class='mx-4  mt-2 subheading' >
    Appointments
  </h3> -->
  <v-card flat>
    <v-list class='pa-0' dense >
      <v-list-tile
        @click='selectAll=!selectAll'
        class='no-pad-left' >
        <v-list-tile-action class='grey lighten-4' style='min-width:30px;' >
            <input
              type='checkbox' class='ml-2'
              v-model='selectAll' />
          </v-list-tile-action>
        <v-divider vertical class='mr-2' ></v-divider>
        <v-list-tile-content >
            <v-list-tile-title>Select all</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-card-text class='px-0 py-0' >
      <v-divider></v-divider>
      <v-expansion-panel expand
        v-if='appointments && appointments.length > 0'
        v-model="panelState"
        class="dense elevation-0" >
        <v-expansion-panel-content
            v-for='(appointment, index) in appointments'
            :key='index' >
            <div slot="header" >
              <!-- <h3 class='subheading' > -->
                <v-layout>
                  <v-flex style='width:70%;' >
                    <v-list-tile class='no-pad-left pl-0' >

                      <v-list-tile-action
                        @click.stop='noop'
                        class='grey lighten-4' style='min-width:30px;'>
                        <input
                            v-if='withSelectable && appointment'
                            @click.stop='$emit("selected", index)'
                            v-model='selectedAppointmentIds'
                            :value='appointment.id'
                            type='checkbox' class='ml-2' />
                      </v-list-tile-action>

                      <v-list-tile-action v-if='actions' >
                        <v-menu
                          open-on-hover offset-y
                          class='pb-0' >
                          <v-btn slot="activator" icon >
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                          <v-list dense >
                            <v-list-tile
                              v-for='item in actions'
                              :disabled='item.disableIf && item.disableIf(appointment)'
                              @click='actionClicked(item, appointment)'
                              :key='item.id' >
                              <v-list-tile-title>{{item.title}}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-list-tile-action>
                      <v-divider vertical class='mr-2' ></v-divider>
                      <v-list-tile-content >
                        <v-list-tile-title>
                          {{ appointment.title || appointment.full_name }}<small v-if='!isCompact'>. {{dateformat(appointment.start_time)}}</small>
                          <v-chip
                            v-if="!isCompact"
                            x-small label dark outline
                            :color='formatStatus(appointment.status).theme'
                            style='float:right;'
                            class='v-chip--x-small pa-0 text-center block' >
                            {{ appointment.status_formatted }}
                          </v-chip>
                        </v-list-tile-title>
                        <v-list-tile-sub-title v-if='isCompact' class='grey--text' >
                          {{dateformat(appointment.start_time)}}
                          <v-chip x-small label dark outline
                            :color='formatStatus(appointment.status).theme'
                            class='v-chip--x-small pa-0 text-center block' >
                            {{ appointment.status_formatted }}
                          </v-chip>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if='!isCompact' class='grey--text' >
                          {{ $tc('codessummary', appointment.codes.length, {n:appointment.codes.length}) }}.
                          {{ $tc('productsummary', appointment.lineitems.length, {n:appointment.lineitems.length}) }}.
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-flex>

                  <v-spacer v-if='!isCompact' class='hidden-xs-only'></v-spacer>
                  <v-btn small icon @click.stop="launchInvoiceDetailsDialog(appointment, false)" class="hidden-xs"  ><v-icon small >edit</v-icon></v-btn>

                  <v-flex v-if='!isCompact' class='text-xs-right hidden-xs-only' >
                    <div class='v-list__tile__action-text' >Total</div>
                    {{ formatCurrency( appointment.currency, appointment.financials.final_price ) }}
                  </v-flex>
                  <v-flex v-if='!isCompact' class='text-xs-right mr-1 hidden-xs-only' >
                    <div class='v-list__tile__action-text' >Payments</div>
                    {{ formatCurrency( appointment.currency, appointment.financials.payments_received ) }}
                  </v-flex>
                  <v-divider v-if='!isCompact' class='hidden-xs-only' vertical ></v-divider>

                  <v-flex xs3 sm1 class='text-xs-right mr-2' >
                    <div class='v-list__tile__action-text' >Outstanding</div>
                    <strong>{{ formatCurrency( appointment.currency, appointment.financials.final_due ) }}</strong>
                  </v-flex>
                  <!-- <span class=' pt-1 mt-2 mr-3' style='float:right' >
                    {{ formatCurrency( appointment.currency, appointment.financials.sub_total ) }}
                  </span> -->
                </v-layout>
              <!-- </h3> -->
            </div>

            <v-sheet >
              <v-list dense subheader >
                <v-subheader class='overline' >
                  Appointment Invoice details
                  <v-spacer></v-spacer>
                  <v-btn @click="launchInvoiceDetailsDialog(appointment, false)" small icon  ><v-icon>edit</v-icon></v-btn>
                </v-subheader>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title >
                      {{appointment.invoice_title || appointment.title}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title >
                      Title
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile v-if='appointment.invoice_description'>
                  <v-list-tile-content>
                    <v-list-tile-title >
                      {{appointment.invoice_description}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title >
                      Description
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile v-if='appointment.product_name'>
                  <v-list-tile-content>
                    <v-list-tile-title >
                      {{appointment.product_name}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title >
                      Appointment type
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if='appointment.product_name'>
                  <v-list-tile-content>
                    <v-list-tile-title >
                      {{ appointment.status_formatted }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title >
                      Appointment status
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-sheet>

            <!-- appointment codes -->
            <v-sheet v-if='appointment.codes && appointment.codes.length > 0'  >
              <appointment-code-list
                :appointment='appointment'
                title='Diagnosis codes'
                @code:deleted='refresh' >
              </appointment-code-list>
            </v-sheet>

          <v-sheet
            v-if='appointment.total_price !== appointment.financials.sub_total'
            class='gray lighten-5' >
            <v-divider ></v-divider>
            <v-list >
              <template >
                <v-list-tile  >
                  <v-list-tile-content >
                    <!-- <v-list-tile-title v-if='appointment.price != appointment.total_price' >
                      Unit price:
                      {{ formatCurrency( appointment.currency, appointment.price ) }}
                    </v-list-tile-title> -->
                    <v-list-tile-sub-title v-if='appointment.discount_amount > 0' >
                      Less
                      {{ formatCurrency( appointment.currency, appointment.discount_amount ) }}
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title v-if='appointment.tax_amount > 0' >
                      Tax
                      {{ formatCurrency( appointment.currency, appointment.tax_amount ) }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action >
                    <v-list-tile-action-text v-if='appointment.tax_amount > 0' >After Tax</v-list-tile-action-text>
                    {{ formatCurrency( appointment.currency, appointment.total_price ) }}
                    <v-list-tile-action-text >Total</v-list-tile-action-text>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-sheet>

          <v-sheet
            v-if='appointment.lineitems && appointment.lineitems.length > 0'
            class='mt-2' >
            <v-list dense subheader >
              <v-subheader >
                <!-- <v-btn icon ><v-icon small>add</v-icon></v-btn> -->
                Other purchases</v-subheader>
              <v-list-tile v-for='product in appointment.lineitems' :key='product.id' >
                <v-list-tile-action class='text-xs-center' >
                  <v-avatar>{{product.quantity}}</v-avatar>
                </v-list-tile-action>
                <v-list-tile-content >
                  <v-list-tile-title>
                    {{ product.description }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    @ {{ formatCurrency( product.currency, product.unit_price) }} each
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action >
                  {{ formatCurrency(product.currency, (product.quantity * product.unit_price)) }}
                  <v-list-tile-action-text>
                    Total
                  </v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
              <v-list>
                <v-list-tile >
                  <v-list-tile-content >
                    <v-list-tile-title>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-list>
          </v-sheet>

          <v-sheet v-if='appointment.payments && appointment.payments.length > 0'  >
            <payment-list
              :appointment='appointment'
              @payment:deleted='refresh'
              title='Payments'
              :payments='appointment.payments' >
            </payment-list>
          </v-sheet>

          <v-divider class='mt-4' ></v-divider>

          <v-sheet >
            <v-list dense subheader class='grey lighten-4' >
              <v-subheader>Totals </v-subheader>
              <v-divider></v-divider>
              <template v-for='item in subtotalList' >
                <v-list-tile
                  v-if='appointment.financials[item.key] > 0'
                  :key='item.key' >
                  <v-list-tile-content >
                    <v-list-tile-title>
                      {{item.text}}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action >
                    {{ formatCurrency( appointment.currency, appointment.financials[item.key] ) }}
                  </v-list-tile-action>
                </v-list-tile>
              </template>
              <v-divider></v-divider>
              <v-list-tile >
                <v-list-tile-content >
                  <v-list-tile-title  class='headline' >
                    Sub total
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action class='headline' >
                  {{ formatCurrency( appointment.currency, appointment.financials.final_due ) }}
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-sheet>


        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-card v-else flat >
        <v-divider></v-divider>
        <v-card-text >
          <v-icon small color='amber'>warning</v-icon>
          No appointments found for
          <strong>{{clientFullname}}</strong> from
          <strong>{{ dateformat(filterFromDate) }}
          <span v-if='filterToDate' > to {{ dateformat(filterToDate) }}</span>
          </strong>
          <!-- <strong>{{globalActiveDateRangeFormatted}}</strong> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click='filterTouch++'
            flat >Change date range</v-btn>
        </v-card-actions>
      </v-card>
      <v-divider></v-divider>
    </v-card-text>
    <v-list dense class='mx-2' v-if='statement && statement.meta' >
      <v-subheader class='overline' >Grand total</v-subheader>
      <v-list-tile >
        <v-list-tile-content ><v-list-tile-title >Total</v-list-tile-title></v-list-tile-content>
        <v-list-tile-action >{{ formatCurrency( defaultCurrency, statement.meta.price_before_tax ) }}</v-list-tile-action>
      </v-list-tile>
      <v-list-tile v-if='statement.meta.tax > 0' >
        <v-list-tile-content ><v-list-tile-title >Tax</v-list-tile-title></v-list-tile-content>
        <v-list-tile-action >{{ formatCurrency( defaultCurrency, statement.meta.tax ) }}</v-list-tile-action>
      </v-list-tile>
      <v-list-tile >
        <v-list-tile-content ><v-list-tile-title >Payments received</v-list-tile-title></v-list-tile-content>
        <v-list-tile-action >{{ formatCurrency( defaultCurrency, statement.meta.payments_received ) }}</v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile >
        <v-list-tile-content ><v-list-tile-title class='headline' >Total due</v-list-tile-title></v-list-tile-content>
        <v-list-tile-action class='headline' >{{ formatCurrency( defaultCurrency, statement.meta.outstanding ) }}</v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-card>
  <v-footer
    v-if='statement && statement.range'
    class="pa-3 mt-4">
    <div >
      Your first appointment with {{normalizedClient.first_name}}
      was on {{ dateformat(statement.range.first_appointment_ever) }}
      ({{ firstAppointmentAgo }}).
    </div>
    <v-spacer></v-spacer>
  </v-footer>

  <v-dialog v-model='dialogs.invoiceSuccess' >
    <invoice-success v-if='newInvoice'
      :client='normalizedClient'
      @done='dialogs.invoiceSuccess = false'
      v-model='newInvoice' >
    </invoice-success>
  </v-dialog>

  <bulk-actions
    :client='normalizedClient'
    :selected-appointments='selectedAppointments'
    @invoice:created = 'setNewInvoice'
    @payment:created = 'paymentAdded'
    @codes:created = 'codesAdded'
    @deselect='selectAll=false;toggleSelectAll()' >
  </bulk-actions>

</div>
</template>

<script>
import PaymentList from './PaymentList'
import AppointmentCodeList from './AppointmentCodeList'
import ClientCard from '@/components/client/ClientCard'
import Filters from './Filters'
import BulkActions from './BulkActions'
import InvoiceSuccess from '@/components/invoice/manage/create/success'
import AppointmentMixins from '@/mixins/appointments'
import moment from 'moment'

export default {
  name: 'StatementIndex',
  mixins: [AppointmentMixins],
  components: {
    Filters,
    ClientCard,
    PaymentList,
    BulkActions,
    InvoiceSuccess,
    AppointmentCodeList
  },
  props: {
    value: { type: Object },
    client: { type: Object },
    loading: { type: Boolean, default: false },
    actionItems: { type: Array },
    filterFromDate: { type: String },
    filterToDate: { type: String },
    filterStatusIds: { type: Array },
    // settings: default true
    withSelectable: { type: Boolean, default: true },
    withReload: { type: Boolean, default: true },
    withFilters: { type: Boolean, default: true },
    withClientPreview: { type: Boolean, default: true },
    // settings: default false
    withInlineControls: { type: Boolean, default: false },
    isCompact: { type: Boolean, default: false },
    withPrevNext: { type: Boolean, default: false },
    initialFilterText: { type: String }
  },
  data () {
    return {
      selectAll: false,
      panelState: [],
      menus: {},
      statement: {},
      appointment: {},
      selectedAppointmentIds: [],
      clientPreviewMenu: false,
      showFilters: false,
      filterString: '',
      filterTouch: 2,
      filters: {},
      dialogs: {
        payments: false,
        invoiceSuccess: false
      },
      newInvoice: false,
      subtotalList: [
        {
          text: 'Appointment cost',
          key: 'appointment_total_price_before_tax'
        },
        {
          text: 'Other products',
          key: 'products_total_price'
        },
        {
          text: 'Tax',
          key: 'appointment_tax'
        },
        {
          text: 'Total',
          key: 'final_price'
        },
        {
          text: 'Payments received',
          key: 'payments_received'
        }
      ]
    }
  },
  mounted () {
    if (this.value) {
      this.statement = this.value
    }
  },
  watch: {
    value () {
      this.statement = this.value
    },
    selectedAppointmentIds () {
      this.$emit('selected:list', this.selectedAppointments)
    },
    client () {
      this.clearSelected()
    },
    selectAll () {
      this.toggleSelectAll()
    },
    globalappdialogwatcher () {
      this.$emit('reload', this.filters)
    }
    // globaldialogvisible () {
    //   if (!this.globaldialogvisible) {
    //     this.$emit('reload', this.filters)
    //   }
    // },
    // activedialog () {
    //   if (!this.activedialog) {
    //     this.$emit('reload', this.filters)
    //   }
    // }
  },
  computed: {
    normalizedClient () {
      if (this.client && this.client.client && this.client.client.id) {
        return this.client.client
      }
      return this.client
    },
    relationshipId () {
      if (this.client) {
        let isRelationship = (this.client.client && this.client.client.id)
        if (isRelationship) {
          return this.client.id
        }
      }
    },
    clientFullname () {
      if (this.client && this.normalizedClient) {
        return `${this.normalizedClient.first_name} ${this.normalizedClient.last_name}`
      }
      return ''
    },
    appointments () {
      if (this.statement && this.statement.results) {
        return this.statement.results
      }
      return []
    },
    selectedAppointments () {
      let vm = this
      return this.appointments.filter((appt) => {
        return vm.selectedAppointmentIds.indexOf(appt.id) !== -1
      })
    },
    actions () {
      if (this.actionItems && this.actionItems.length > 0) {
        return this.getAppointmentActionItemsByKeyList(this.actionItems)
      }
    },
    firstAppointmentAgo () {
      if (this.statement && this.statement.range) {
        return moment(this.statement.range.first_appointment_ever)
          .fromNow()
      }
    }
  },
  methods: {
    noop () {},
    actionClicked (action, appointment) {
      // console.log(appointment)
      this.$emit('action', action, appointment)
    },
    setNewInvoice (invoice) {
      this.refresh()
      this.newInvoice = invoice
      this.dialogs.invoiceSuccess = true
    },
    paymentAdded (payment) {
      this.refresh()
    },
    codesAdded (payment) {
      this.refresh()
    },
    clearSelected () {
      this.selectedAppointmentIds = []
    },
    setFilters (params) {
      this.filters = params
      this.refresh()
    },
    clearFilters () {
      this.filters = {}
      this.refresh()
    },
    setFilterString (str) {
      this.filterString = str
    },
    refresh () {
      this.$emit('reload', this.filters)
    },
    toggleSelectAll () {
      if (this.selectAll) {
        this.selectedAppointmentIds = this.appointments.map((appt) => {
          return appt.id
        })
      } else {
        this.selectedAppointmentIds = []
      }
    }
  },
  i18n: {
    messages: {
      en: {
        codessummary: 'no diagnosis codes|1 diagnosis code|{n} diagnosis codes',
        productsummary: 'no products|1 product|{n} products'
      }
    }
  }
}
</script>

<style scoped >
.loading {
  opacity: 0.3;
}
</style>
<style >
.v-expansion-panel.dense .v-expansion-panel__header {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// index.vue?50a5d5e9